import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { MergeDataset } from '../../decorators/decorators/merge.dataset';
import { ContactMergeDataset } from './contact.merge.dataset';

@MergeDataset({
    entity: ActivityEntityName.LoginContact,
})
export class LoginContactMergeDataset extends ContactMergeDataset {
}
